import React, { Component } from "react";
import firebase from "firebase";
import firebaseui from "firebaseui";
import "./SignInOptions.css";

class SignInOptions extends Component {
  constructor() {
    super();
    this.ui =
      firebaseui.auth.AuthUI.getInstance() ||
      new firebaseui.auth.AuthUI(firebase.auth());
  }

  componentDidMount() {
    this.ui.start("#firebaseui-auth-container", {
      callbacks: {
        signInSuccess: function(currentUser, credential, redirectUrl) {
          // User successfully signed in.
          // Return type determines whether we continue the redirect automatically
          // or whether we leave that to developer to handle.
          return true;
        },
      },
      signInFlow: "popup",
      signInSuccessUrl: "/",
      tosUrl: "/privacy-tos",
      privacyPolicyUrl: "privacy-tos",
      credentialHelper: firebaseui.auth.CredentialHelper.NONE,
      signInOptions: [
        // List of OAuth providers supported.
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
      ],
      // Other config options...
    });
  }

  render() {
    return (
      <div className="sign-in-options-container">
        <div className="modal-title">Sign Up</div>
        <div id="firebaseui-auth-container" />
      </div>
    );
  }
}

export default SignInOptions;



// WEBPACK FOOTER //
// ./src/components/SignInOptions.js